import { useCallback, useEffect, useMemo, useRef, useState } from "react";

const diffTime = (ms) => {
  const totalMinutes = Math.max(0, Math.floor(ms / 60000));
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  return { days, hours, minutes };
};

export const useTournamentTimer = (startDateStr, endDateStr) => {
  const { startMs, endMs } = useMemo(() => {
    const start = new Date(startDateStr);
    const end = endDateStr ? new Date(endDateStr) : new Date(start);

    if (!endDateStr) end.setMonth(end.getMonth() + 1);

    return { startMs: start.getTime(), endMs: end.getTime() };
  }, [startDateStr, endDateStr]);

  const calcTime = useCallback(() => {
    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) {
      return { days: 0, hours: 0, minutes: 0, state: "ended" };
    }

    const now = Date.now();

    if (now < startMs) return { ...diffTime(startMs - now), state: "waitStart" };
    if (now < endMs) return { ...diffTime(endMs - now), state: "started" };
    return { days: 0, hours: 0, minutes: 0, state: "ended" };
  }, [startMs, endMs]);

  const [time, setTime] = useState(() => calcTime());

  const intervalRef = useRef(null);
  useEffect(() => {
    setTime(calcTime());
    const tick = () => setTime(calcTime());
    intervalRef.current = setInterval(tick, 60 * 1000);
    return () => clearInterval(intervalRef.current);
  }, [calcTime]);

  return time;
};
